import React from 'react'

// o children será o texto que é escrito no botão
// as colores recebe todas as cores do bulma sem o "IS-"
// o action recebe o função que ao apertar o botão ela será executada

export const ButtonContentBt = ({
  children,
  className = '',
  color = 'is-light',
  colorText = null,
  size = null,
  action = () => {},
  disabled = null,
  isHidden = false,
  type = 'button',
  loading = null,
  msgDisabled = '',
  title = '',
  titleBehind = '',
}) => {
  if (!isHidden) {
    return (
      <div
        className="my-2"
        style={{
          display: 'flex', // ativa flexbox
          flexDirection: 'column', // se quiser empilhar verticalmente
          justifyContent: 'center', // centraliza verticalmente
          alignItems: 'center', // centraliza horizontalmente
        }}
      >
        <button
          className={`button ${color} ${size} ${colorText} ${className} ${loading && 'is-loading'}`}
          onClick={(event) => {
            event.stopPropagation()
            action()
          }}
          disabled={disabled}
          type={type}
          title={disabled ? msgDisabled : title}
        >
          {children}
        </button>
        {titleBehind !== '' ? (
          <p style={{ textAlign: 'center', fontSize: 10, maxWidth: '90%' }} className="has-text-grey mt-1">
            {titleBehind.split(' ').map((word, index) => (
              <span key={index} style={{ display: 'block' }}>
                {word}
              </span>
            ))}
          </p>
        ) : null}
      </div>
    )
  } else {
    return <></>
  }
}
